/*
 * NYORD: dezenter Aufmerksamkeits-Glanz auf dem Warenkorb-Knopf der Produktseite (ersetzt Vitals „Animated Add to
 * Cart“). Ein Lichtstreif läuft über den goldenen Knopf, der Knopf hebt sich dabei um 2 px. Nur wenn der Knopf (oder
 * der Knopf der Kaufleiste) sichtbar ist und die Person gerade nicht scrollt, höchstens 5-mal pro Seitenaufruf,
 * nach dem ersten Klick auf „In den Warenkorb“ gar nicht mehr. Bei „Bewegung reduzieren“ aus. Styles in nb-produkt.css.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ERSTE = 3500;
  var ABSTAND = 8000;
  var NOCHMAL = 1500;
  var MAX = 5;
  var anzahl = 0;
  var aus = false;
  var timer = null;
  var letzteAktion = 0;

  function ziele() {
    return [
      document.querySelector('.nb-kaufleiste--an .nb-kaufleiste__knopf'),
      document.querySelector('.nb-pdp .product-form__submit[name="add"]'),
    ];
  }

  function sichtbar(el) {
    if (!el || el.disabled) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
  }

  function glanz(el) {
    var streif = el.querySelector(':scope > .nb-glanz');
    if (!streif) {
      streif = document.createElement('span');
      streif.className = 'nb-glanz';
      streif.setAttribute('aria-hidden', 'true');
      el.appendChild(streif);
    }
    el.classList.remove('nb-glanz--los');
    void el.offsetWidth;
    el.classList.add('nb-glanz--los');
    setTimeout(function () {
      el.classList.remove('nb-glanz--los');
    }, 1400);
  }

  function planen(ms) {
    if (timer || aus || anzahl >= MAX) return;
    timer = setTimeout(takt, ms);
  }

  function takt() {
    timer = null;
    if (aus || anzahl >= MAX) return;
    // Nicht stören, solange gescrollt oder getippt wird; dann gleich noch einmal schauen
    if (document.hidden || Date.now() - letzteAktion < 2000) return planen(NOCHMAL);
    var el = ziele().filter(sichtbar)[0];
    if (!el) return planen(NOCHMAL);
    glanz(el);
    anzahl++;
    planen(ABSTAND);
  }

  ['scroll', 'pointerdown', 'keydown', 'touchstart'].forEach(function (typ) {
    window.addEventListener(
      typ,
      function () {
        letzteAktion = Date.now();
      },
      { passive: true }
    );
  });
  document.addEventListener(
    'click',
    function (e) {
      if (e.target.closest && e.target.closest('.product-form__submit, .nb-kaufleiste__knopf')) aus = true;
    },
    true
  );
  planen(ERSTE);
})();
